import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { ShowModalContainer } from 'containers/ShowModalContainer';

import { StyledDropdownItem } from './ListingActionsDropdown.styled';
import { ListingActionsDropdownListingType } from './ListingActionsDropdownTypes';

type Props = {
  closeMenu: () => void;
  listing: ListingActionsDropdownListingType;
  mobileOnly?: boolean;
};

export function ShareMenuItem({ closeMenu, listing, mobileOnly }: Props) {
  if (
    listing.type === 'GRAD_PROGRAM' ||
    (listing.type !== 'ORG' && !listing.org)
  ) {
    return null;
  }

  return (
    <ShowModalContainer
      render={(showModal) => (
        <StyledDropdownItem
          $mobileOnly={mobileOnly}
          data-qa-id="share-button"
          onClick={(e) => {
            e.preventDefault();

            closeMenu();

            showModal('SHARE_LISTING', {
              listingType: listing.type,
              listing,
            });
          }}
        >
          <Box mr="10px">
            <Icon name="share" size={16} />
          </Box>
          {getText('Share')}
        </StyledDropdownItem>
      )}
    />
  );
}
